import api from "./axios";

// Notification Types
export interface Notification {
  id: string;
  user_id: string;
  title: string;
  notification_type: string;
  notification_status: "READ" | "UNREAD";
  created_at: string;
  read_at: string | null;
  sent_at: string | null;
  action_link: string | null;
  object_id: string;
}

export interface NotificationCountResponse {
  count: number;
}

export interface NotificationsResponse {
  items: Notification[];
  total: number;
}

// Notifications API
export const notificationsApi = {
  // Get notification count
  getCount: async (): Promise<NotificationCountResponse> => {
    const response = await api.get("/notifications/count");
    const data = response?.data;
    
    // Handle both string/number and object responses
    if (typeof data === 'string' || typeof data === 'number') {
      return { count: parseInt(String(data), 10) };
    }
    
    if (data && typeof data.count === 'number') {
      return data;
    }
    
    return { count: 0 };
  },

  // Get all notifications
  getAll: async (): Promise<NotificationsResponse> => {
    const response = await api.get("/notifications");
    // Handle various response formats
    const data = response?.data;
    
    if (!data) {
      return { items: [], total: 0 };
    }
    
    // If response is already an array
    if (Array.isArray(data)) {
      return { items: data, total: data.length };
    }
    
    // If response has items property (actual API format)
    if (data.items && Array.isArray(data.items)) {
      return { items: data.items, total: data.total || data.items.length };
    }
    
    // Default fallback
    return { items: [], total: 0 };
  },

  // Mark notification as read
  markAsRead: async (notificationId: string): Promise<void> => {
    await api.put(`/notifications/${notificationId}/read`);
  },

  // Mark all notifications as read (optional utility method)
  markAllAsRead: async (): Promise<void> => {
    await api.put("/notifications/read-all");
  },
};

